import { GetAgentStatusResponse } from './types';

// Shared mock used by RewardsTab and TwentySixForTwentySix when
// REWARDS_MOCK_ENABLED is set. Not imported in production paths.
// progress values are internally consistent with MOCK_REWARDS_CONFIG's
// entry_threshold of 5: 3 binds + 2 remaining = 5-per-entry cycle.
export const MOCK_AGENT_STATUS: GetAgentStatusResponse = {
  availableEntries: 5,
  hasActiveAttempt: false,
  activeAttemptId: null,
  lastResult: null,
  progress: { qualifyingBindsCurrentPhase: 3, policiesUntilNextEntry: 2 },
  phase: {
    number: 2,
    code: 'ACT2',
    name: 'Act 2',
    start: '2026-07-08T00:00:00Z',
    end: '2026-09-30T23:59:59Z',
    attemptType: 'SPIN',
  },
  balance: { regular: 2, bonus: 3, bonusExpiresAt: '2026-09-30T23:59:59Z' },
};
